import { T } from "../constants/theme";

export default function Input({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  required,
  hint,
  error,
}) {
  return (
    <div style={{ marginBottom: 18 }}>
      <label
        style={{
          display: "block",
          fontSize: 13,
          fontWeight: 600,
          color: T.gray800,
          marginBottom: 5,
        }}
      >
        {label} {required && <span style={{ color: T.saffron }}>*</span>}
      </label>

      {hint && (
        <p style={{ fontSize: 12, color: T.gray600, marginBottom: 5 }}>
          {hint}
        </p>
      )}

      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "10px 13px",
          borderRadius: 8,
          border: `1.5px solid ${error ? T.red : T.gray200}`,
          fontSize: 14,
          color: T.gray800,
          background: T.white,
          boxSizing: "border-box",
        }}
        onFocus={(e) => (e.target.style.borderColor = T.indigo)}
        onBlur={(e) =>
          (e.target.style.borderColor = error ? T.red : T.gray200)
        }
      />

      {error && (
        <p style={{ fontSize: 12, color: T.red, marginTop: 4 }}>
          ⚠ {error}
        </p>
      )}
    </div>
  );
}